import clsx from "clsx"
import { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { MediaMobile } from "../../../../api/const/MediaQuery"
import useMediaQuery from "../../../../hook/useMediaQuery"
import { AppGeneralContext } from "../../../../shared/GeneralContext/GeneralContext"
import { Button } from "../../../atoms"
import { MatchDate } from "../../../types/types"
import { DatesForm } from "./DatesForm"
import { StepperDatesHeader } from "./StepperDatesHeader"

export const SelectSecondDate = (props: any) => {
    const { matchCallDates, setMatchCallDates, resetMatchCallDates, setModalDatesIsOpen } = useContext(AppGeneralContext)
    const [date, setDate] = useState<string | Date>()
    const [isDisabled, setIsDisabled] = useState<boolean>(true)
    const mobile = useMediaQuery(MediaMobile)
    const [errorMessage, setErrorMessage] = useState("")

    const getDate = (finalDate: string | Date) => {
      
        setDate(finalDate);
        setIsDisabled(false)
    }

    const cancel = () => {
        resetMatchCallDates();
        props.goToStep(1);
        setModalDatesIsOpen(false);
    }

    useEffect(()=>{
        if(date && errorMessage) {
            const date1 = new Date(matchCallDates?.[0].date as any)
            const date2 = new Date(date)

            if(date1.toISOString() === date2.toISOString()){
                setErrorMessage("Date already selected")
                return
            }
            setErrorMessage("")
        }

    },[date, errorMessage, matchCallDates])

    const save = useCallback(
        () => {
            if (date) {

                let secondDate: MatchDate[] = [{
                    id: "secondDate",
                    date: date
                }]

                const date1 = new Date(matchCallDates?.[0].date as any)
                const date2 = new Date(date)

                if (date1.toISOString() === date2.toISOString()) {
                    setErrorMessage("Date already selected")
                    return
                }
                setErrorMessage("")

                if (matchCallDates) {
                    let firstPlusSeconDate = matchCallDates.concat(secondDate)
                    setMatchCallDates(firstPlusSeconDate)
                    props.nextStep()
                }
            }
        },
        [date, JSON.stringify(matchCallDates)],
    )

    const dateForm = useMemo(() => {
        return <DatesForm getValue={(date) => getDate(date)} />

    }, [date, getDate])


    return (
        <div className=" mt-3 position-relative">
            <StepperDatesHeader title={"SECOND DATE"} />
            <div className="d-flex flex-column justify-content-between">
                {dateForm}
                {errorMessage && <div className="text-error w-100 text-center fw-600 mt-2">{errorMessage}</div>}
                <div className={clsx("d-flex pt-4  ",
                    { "justify-content-end flex-row": !mobile },
                    { "justify-content-center align-items-center flex-column-reverse mb-5": mobile })}>
                    <Button primary text={"CANCEL"} background={"transparent"}
                        color={"black"} borderColor={"var(--black)"}
                        className={clsx("",
                            { "me-4": !mobile },
                            { "mt-2": mobile })}
                        onClick={() => cancel()} />
                    <Button primary disabled={isDisabled} text={"NEXT DATE"} background={"var(--primary)"}
                        color={"white"} borderColor={"var(--primary)"}
                        onClick={() => save()}
                    />
                </div>
            </div>
        </div>
    )

}